import React from 'react';
import { useTranslate } from '../../../mixins/translate/translate';
import { IconButton } from './IconButton';

export function IconEditButton(props: { onClick: () => void }) {
    const translate = useTranslate();
    return <IconButton iconClass="fa-edit" onClick={props.onClick} title={translate('common.edit')} />;
}
